import getGlobalDiscountsMenu from './getGlobalDiscountsMenu';
import { WEEKLY } from '../constants';

const getGlobalDiscountsPickup = state => {
  const discounts = getGlobalDiscountsMenu(state)?.discounts;

  return discounts?.length > 0
    ? discounts.find(({ type }) => type === WEEKLY)
    : null;
};

export default getGlobalDiscountsPickup;
